import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const ppuMetricData = z.object({
  valuesByTreatment: z.array(
    z.object({ treatmentId: zExt.objectId(), value: z.number() }),
  ),
  confidencesByTreatment: z
    .array(z.object({ treatmentId: zExt.objectId(), confidence: z.number() }))
    .nullable(),
});

export enum PpuAbTestMetric {
  CONVERSION_RATE = "conversionRate",
  REVENUE_PER_VISIT = "revenuePerVisit",
  TOTAL_REVENUE = "totalRevenue",
  ACCEPTED_OFFERS = "acceptedOffers",
}

type PpuMetricsShape = { [key in PpuAbTestMetric]: typeof ppuMetricData };

export const getPpuAbTestMetrics = {
  name: "getPpuAbTestMetrics" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.object<PpuMetricsShape>({
    [PpuAbTestMetric.CONVERSION_RATE]: ppuMetricData,
    [PpuAbTestMetric.REVENUE_PER_VISIT]: ppuMetricData,
    [PpuAbTestMetric.TOTAL_REVENUE]: ppuMetricData,
    [PpuAbTestMetric.ACCEPTED_OFFERS]: ppuMetricData,
  }),
};

export type GetPpuAbTestMetricsOutput = z.infer<
  typeof getPpuAbTestMetrics.output
>;
